<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> Used Device Detail
      </h1>
    </div>
    <div class="page-filter clearfix multiple-filter">
      <div class="filter-flex">
        <div class="filter">
          <div class="filter-list name_title">
            <div class="filter-content date">
              <p-datepicker [(ngModel)]="datePickStart" view="month" dateFormat="mm/yy" yearNavigator="true" yearRange="2024:2070" [showIcon]="true"
                dateFormat="{{preferenceService.dateFormat.replace('yyyy', 'yy').replace('MM', 'mm').replace('/dd', '')}}" (ngModelChange)="changeDate($event)"
                [minDate]="minEndDate" [maxDate]="maxEndDate">
              </p-datepicker>
            </div>
          </div>
        </div>
        <div class="filter float-right">
          <div class="button">
          </div>
        </div>
      </div>
    </div>
    <div class="page-filter clearfix border-b-radius-none" style="margin: 0" *ngIf="licenseUsageList.length > 0">
      <div class="page-title sub-title">
        <h5 class="float-left">Device Usage</h5>
      </div>
    </div>
    <section style="margin: 0 0 0 0;" *ngIf="licenseUsageList.length > 0">
      <div class="content-info licenseUsedDetail border-t-radius-none">
        <p-treeTable [value]="licenseUsageList" [columns]="licenseUsedDetailTable_cols">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr>
              <td>
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                {{rowData.name}}
              </td>
              <td>{{rowData.quantity}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td>Total</td>
              <td>{{deviceUsageTotal.quantity}}</td>
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </section>
  </div>
</div>
